import { matchdayPrefix } from '../data/folder-prefix';

const BASE_FOLDER = 'espn/logo-vs-logo';

const slug = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Builds "espn/logo-vs-logo/<league>[/<prefix>-NN]".
// League without matchday → league folder only. Prefix (fecha/jornada) comes from the league.
export const buildFolder = (league: string | undefined, matchday: string | undefined): string | undefined => {
  if (!league) return undefined;
  const base = `${BASE_FOLDER}/${slug(league)}`;
  const md = matchday?.trim();
  if (!md) return base;
  const prefix = matchdayPrefix(league);
  const n = Number(md);
  const label = Number.isInteger(n) ? `${prefix}-${String(n).padStart(2, '0')}` : `${prefix}-${slug(md)}`;
  return `${base}/${label}`;
};
